import React from 'react';
import withIcon from '../utilities/withIcon';

const IconEmail = () => {
  return (
    <g>
      <path d="m15.91 2.7692a.7258.7258 0 0 0 -.0319-.1581.7209.7209 0 0 0 -.0787-.1371.7092.7092 0 0 0 -.0547-.0951c-.0056-.0064-.0137-.0087-.0195-.0148a.7418.7418 0 0 0 -.1309-.0994.7537.7537 0 0 0 -.1047-.0706.7531.7531 0 0 0 -.1281-.0338.7384.7384 0 0 0 -.1564-.0316c-.0084 0-.0154-.0048-.0239-.0048h-14.3624c-.0085 0-.0156.0045-.024.0048a.7447.7447 0 0 0 -.1571.0317.7581.7581 0 0 0 -.1277.0337.7553.7553 0 0 0 -.1058.0714.7392.7392 0 0 0 -.13.0987c-.0052.0058-.0132.0084-.0188.0147a.711.711 0 0 0 -.0547.0951.7218.7218 0 0 0 -.0787.1371.7258.7258 0 0 0 -.032.1581.7021.7021 0 0 0 -.0212.1048v10.252a.75.75 0 0 0 .75.75h14.3624a.75.75 0 0 0 .75-.75v-10.252a.7018.7018 0 0 0 -.0212-.1048zm-2.7191.8548-5.1909 4.5601-5.1909-4.5601zm-11.6221 8.752v-7.8447l5.936 5.2148a.75.75 0 0 0 .99 0l5.936-5.2148v7.8447z" />
    </g>
  );
};

export default withIcon(IconEmail);
